import React from 'react';

interface SwitchProps {
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  checked?: boolean;
  htmlFor?: string;
  size?: 'md' | 'sm';
  name?: string;
}

function Switch({
  onChange,
  htmlFor,
  disabled,
  checked,
  size = 'md',
  name,
}: SwitchProps) {
  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(event);
  };
  const switchSize = {
    md: {
      container: 'w-10 h-[20px]',
      circle:
        'before:h-[13.33px] before:w-[10px] before:left-[3.33px] before:bottom-[3px]',
    },
    sm: {
      container: 'w-[41px] h-[21px]',
      circle:
        'before:h-[16px] before:w-[16px] before:left-[3px] before:bottom-[2.4px] slider-sm',
    },
  };
  return (
    <label
      className={`switch relative inline-block ${switchSize[size].container} ${
        disabled ? ' cursor-not-allowed' : ' cursor-pointer'
      }`}
      htmlFor={htmlFor}
    >
      <input
        type="checkbox"
        className="w-0 h-0 opacity-0 disabled:pointer-events-none"
        disabled={disabled}
        onChange={onChangeHandler}
        id={htmlFor}
        checked={checked}
        name={name}
      />
      <span
        className={`slider absolute top-0 left-0 bottom-0 right-0 bg-lightBlue transition-all rounded-[3.33px] before:rounded-[3.33px] before:absolute ${switchSize[size].circle} before:bg-white before:transition-all before:shadow-lg`}
      ></span>
    </label>
  );
}

export default Switch;
